/*
 * Created by Joseph Saliba on 08/27/18.
 */
namespace app.model {
  export class SortOperation {
    public sortBy: string;
    public sortDirection: SortDirection;
  }
}
